/* Daza Organic · movimiento de la ficha de producto
   Entrada escalonada de los bloques de la columna de información al
   aparecer en pantalla. El acordeón (abrir/cerrar) ya no lo anima este
   archivo: es puro CSS (grid-template-rows en daza-caja-compra.css), así
   no depende de medir alturas ni de pelear con el <details> nativo.
   Respeta prefers-reduced-motion: si está activo, no se toca nada. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function entrada(cont) {
    if (cont.dataset.dazaMotion || reduce.matches || !('IntersectionObserver' in window)) return;
    cont.dataset.dazaMotion = '1';

    var bloques = [].slice.call(cont.children).filter(function (el) {
      return !/^(SCRIPT|STYLE|TEMPLATE|INPUT)$/.test(el.tagName) && !el.hidden;
    });
    if (!bloques.length) return;

    bloques.forEach(function (el) { el.classList.add('daza-reveal'); });
    cont.classList.add('daza-motion');

    var io = new IntersectionObserver(function (entradas) {
      var n = 0;
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        el.style.setProperty('--daza-i', Math.min(n++, 8));
        el.classList.add('is-in');
        // Al terminar se retiran las clases: el bloque vuelve a sus propias
        // transiciones (hover, etc.) sin el retraso de la entrada encima.
        setTimeout(function () {
          el.classList.remove('daza-reveal', 'is-in');
          el.style.removeProperty('--daza-i');
        }, 1400);
      });
    }, { rootMargin: '0px 0px -6% 0px' });

    bloques.forEach(function (el) { io.observe(el); });
  }

  function arrancar() {
    [].slice.call(document.querySelectorAll('.product__info-container')).forEach(entrada);
  }

  if (document.readyState !== 'loading') arrancar();
  else document.addEventListener('DOMContentLoaded', arrancar);
  document.addEventListener('shopify:section:load', arrancar);
})();
